<template>
    <validation-observer ref="plusMinusForm">
        <div>
        <div class="form-group p-0-14">
            <div class="plus-minus-attribute">
                <label class="attribute-label">
                    {{ attribute.attribute_name }}
                    <a href="javascript:;" data-toggle="popover" data-placement="bottom" data-html="true" :data-content="popover_custom_data(attribute.extra_info)" v-if="removeTags(attribute.extra_info) !== ''">
                        <i class="fa fa-info-circle"></i>
                    </a>

                    <span class="cost-attribute"  style="text-align: left;">
                                 <span v-if="attribute.unit_price"  class="unit_priceeData">
                                     +{{ priceText(attribute.unit_price, attribute.cost_type,currency,unit) }}
                                </span>
                      <span v-if="attribute.attribute_additional_time "  class="attribute_additional_timeData"> {{  callAdditionalTimeTextData(attribute.attribute_additional_time)}} </span>
                      </span>

                </label>
                <validation-provider :rules="attribute.mandatory ? 'required' : ''" v-slot="{errors}">
                <div class="input-group">

                    <span class="input-group-btn input-group-prepend">
                        <button class="btn btn-outline bootstrap-touchspin-down minus-btn" @click="minus" type="button">-</button>
                    </span>

                    <input type="text" :name="name" :id="id" :value="numberValue" @input="onChange" ref="input"   class="text-center form-control">
                    <span class="input-group-addon bootstrap-touchspin-postfix input-group-append"   v-if="attribute.title !== ''">
                        <span   class="input-group-text p-10">{{ attribute.title }}</span>
                    </span>
                    <span class="input-group-btn input-group-append">
                        <button class="btn btn-outline bootstrap-touchspin-up plus-btn" @click="plus"
                                type="button">+</button>
                    </span>
                </div>
                    <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
        </div>
    </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {priceText} from "@/events/sharedMethods.js";

export default {
    name: "PlusMinusAttribute",
    props: {
        attributes: {
            type: Array,
            default() {
                return []
            }
        },
        attribute: {
            type: Object,
            required: true
        },
        value: 0,
        dateFormat: null,
        timeFormat: null,
        clone: 0,
        unit: {
            required: true
        },
        currency: {
            required: true
        }
        ,
        additionalTimeTextData:Function
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            numberValue: 0,
            selected:[]
        }
    },
    computed: {
        /**
         * gets all dependencies of the selected attribute
         * @returns {T[]|*[]}
         */
        dependency() {
            if (this.selected && this.selected.dependency) {
                return this.attributes.filter(attribute => this.selected.dependency.includes(attribute.attribute_id))
            }
            return []
        },
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
        }
    },
    methods: {
        addEventListeners() {

            EventBus.$on('onServiceAttributesValidation', async (verify) => {
                let validated = await this.$refs.plusMinusForm.validate();
                if(!validated)
                {
                    /** If there is a validation error then show the validation and open collapsed services  **/
                    EventBus.$emit('onCollapseService',this.attribute)

                }
                verify(validated)
            })



        }
        ,
        callAdditionalTimeTextData(val){
            return  this.additionalTimeTextData(val);
        }
        ,

        /**
         * pick a value
         * @param value
         */
        onChange(event) {

            let value = event.target.value

            if (this.isNumberWithinRange(value)) {
                this.numberValue = value
            } else if (!this.isNumberWithinRange(value) && this.isHigherThanMax(value)) {
                this.numberValue = +this.attribute.max
                this.$refs.input.value = this.attribute.max
            } else if (!this.isNumberWithinRange(value) && this.isLowerThanMin(value)) {
                this.numberValue = +this.attribute.min
                this.$refs.input.value = this.attribute.min
            }

            this.$emit('input', this.numberValue);
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribute,
                value: this.numberValue
            })
        },
        isNumberWithinRange(number) {
            return number >= this.attribute.min && number <= this.attribute.max
        },
        isAlreadyEqualToMin(number) {
            return number === this.attribute.min
        },
        isAlreadyEqualToMax(number) {
            return number === this.attribute.max
        },
        isHigherThanMax(number) {
            return number > this.attribute.max
        },
        isLowerThanMin(number) {
            return number < this.attribute.min
        },
        minus() {
            if (this.isNumberWithinRange(this.numberValue) && !this.isAlreadyEqualToMin(this.numberValue)) {
                this.numberValue--
                this.$emit('input',this.numberValue)
                // EventBus.$emit('onCustomFieldUpdated', {
                //     attribute: this.attribute,
                //     value: this.numberValue
                // })
                // for (let i = 1; i < 2; i++) {
                //     EventBus.$emit('onServiceCustomFieldSelected', this.attribute)
                // }

            }
        },
        plus() {
            if (this.isNumberWithinRange(this.numberValue) && !this.isAlreadyEqualToMax(this.numberValue)) {
                this.numberValue++
                this.$emit('input',this.numberValue)
            }
        },
        triggerChange() {
            EventBus.$emit('onServiceCustomFieldSelected',this.attribute.service_id,this.clone)
        },
        priceText,
        removeObjectWithId(arr, id) {
            const found = arr.filter(element => element.attribute_id == id);
            const count = arr.filter(element => element.attribute_id == id).length;
            arr.splice(found, count);
        },
        removeTags(value) {
            const div = document.createElement('div');
            div.innerHTML = value;
            var DataToAdd=null
            if(div.textContent){
                DataToAdd= div.textContent
            }
            else if(div.innerText){
                DataToAdd= div.innerText
            }else{   DataToAdd= '';  }
            if(DataToAdd){
                return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
            }else {
                return DataToAdd;
            }
            },
        popover_custom_data(value) {
            return  `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;;
        },
    },
    mounted() {
        if (this.attribute.service_attribute_value) {
            this.numberValue = this.attribute.service_attribute_value
        }else {
            this.numberValue = this.value || this.attribute.min
        }
        this.addEventListeners()
    },
    watch: {
        numberValue: {
            handler: function (data) {
                this.removeObjectWithId(this.selected, this.attribute.attribute_id);
                for (let i = 0; i < data; i++) {
                    this.selected.push(this.attribute);
                }
                this.$nextTick(() => {
                    this.attribute.value = this.numberValue;
                    this.attribute.service_attribute_value = this.numberValue;
                    this.triggerChange()
                });

            },
            deep: true
        }
    }
}
</script>

<style scoped>
@media (max-width: 768px) {
    .input-group-addon{
        padding: 0px !important;
        white-space: break-spaces;
    }
}

</style>